import { Route, Switch } from "react-router-dom"
import About from "../Pages/About"
import Home from "../Pages/Home"

const Routes = () =>{
    return(
        <Switch>
            <Route exact path={'/'}>
                <Home/>
            </Route>
            <Route path={'/about'}>
                <About/>
            </Route>
        </Switch>
    )
}

export default Routes